import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import Fade from 'react-reveal/Fade'

export default function CategorisedVideos ({ category, videos, showModal }) {
  return (
    <Fade>
      <p className="cat-title">{category}</p>
      <div className="d-flex flex-wrap listing">
        {videos.filter(vid => vid.category === category).map((item, index) =>
          <LazyLoadComponent key={`video-${index}`}>
            <div className="infographic" onClick={() => showModal(item)}>
              <img className="image" src={item.thumbnail} alt={`video-${index}`} />
              <div className="overlay">
                <button className="gallery-btn">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#26b4a9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polygon points="10 8 16 12 10 16 10 8"></polygon>
                  </svg>
                  Play Video
                </button>
              </div>
            </div>
          </LazyLoadComponent>
        )}
      </div>
    </Fade>
  )
}